import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import './assets/index.css'  // <-- 引入 Tailwind 样式

createApp(App)
    .use(router) // 这里用到 router
    .mount('#app')
